import React, { useState } from 'react'
import { connect } from 'react-redux'
import QandAForm from '../../components/Questions/QandAForm'
import QandASubmitted from '../../components/Questions/QandASubmitted'
import Breadcrumb from '../../components/Breadcrumbs/Breadcrumb'
import ErrorPage from '../../components/ErrorPage/ErrorPage'
// import updateDigitalData, { doTrack } from '../../helpers/taggingSerializer'
import * as Styled from './QuestionsPage.styles'

function QuestionsPage({ ...props }) {
  const [pageView, setPageView] = useState('form')
  const [submitResponse, setSubmitResponse] = useState('')
  const { productId, productName, type } = props
  /* useEffect(() => {
    const { errorCode, errorDetail } = props
    if (!errorCode && !errorDetail) {
      const stores = {
        productStore: props.productStore,
      }
      updateDigitalData(stores, 'Initial questions page load')
      doTrack('questions_newPage')
    }
  }) */

  const breadcrumb = [
    {
      id: productId,
      name: productName,
      url: `/product/${productId}`,
      type: 'product'
    }
  ]

  async function postData(data) {
    const url = '/product-api/bazaar-voice-submit-questions'
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    })
    return response.json()
  }

  const onSubmit = data => {
    const bodyData = {
      ...data,
      productId,
      questionId: props.question?.id
    }
    postData(bodyData).then(response => {
      setSubmitResponse(response)
      setPageView('submit')
    })
  }

  if (props.errorCode || props.errorDetail) {
    return <ErrorPage failureStatus={props.errorCode || 404} />
  }

  return (
    <Styled.Container className='pdp-main clearfix'>
      <div className='container'>
        <Styled.Wrapper>
          <section className='xs-12--none'>
            <Breadcrumb className='xs-row pdp-breadcrumbs' currentCategoryName='Questions' ancestors={breadcrumb} />
          </section>

          <Styled.Main>
            {pageView === 'form' && <QandAForm {...{ onSubmit, ...props }} />}
            {pageView === 'submit' && <QandASubmitted type={type} submitResponse={submitResponse} />}
          </Styled.Main>
        </Styled.Wrapper>
      </div>
    </Styled.Container>
  )
}

const mapStateToProps = (state, ownProps) => {
  const { productStore, bazaarVoiceQuestionAnswer = {} } = state

  const {
    data: { productName, productId, media },
    meta: { errorCode, errorDetail }
  } = productStore
  const { data = {} } = bazaarVoiceQuestionAnswer
  const { productQuestions = {} } = data
  const questions = productId && (productQuestions[productId] || [])

  const props = {
    ...ownProps,
    productStore,
    productName,
    productId,
    question: questions && questions[0],
    type: questions.length > 0 ? 'answer' : 'question',
    images: media?.images,
    errorCode,
    errorDetail
  }
  return props
}

export default connect(mapStateToProps)(QuestionsPage)
export { QuestionsPage, mapStateToProps }
